import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseToast() {
  const [visible, setVisible] = useState<boolean>(false);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(showTimer);
  }, []);
  return <AnimatePresence data-id="element-241" data-mp="2quq2odo2htwa">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} role="status" aria-live="polite" className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm rounded-2xl border border-line bg-raised p-4 shadow-2xl sm:left-4 sm:right-auto" data-id="element-242" data-mp="2qvhv5fmdbbic">
          <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute right-3 top-3 text-neutral-500 transition-colors duration-150 ease-out hover:text-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-243" data-mp="f79uugjfbjc8">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="236xt8267gd7e" />
          </button>
          <p className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.15em] text-gold" data-id="element-245" data-mp="2860kmjt9ikww">
            <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-246" data-mp="1bgszhcwk2dti" />
            Compra verificada
          </p>
          <p className="mt-2 pr-6 text-sm text-neutral-200" data-id="element-247" data-mp="1fieizh3lhqco">
            <span className="font-bold text-white" data-id="element-248" data-mp="1kgy5bim3p45k">Gonzalo M.</span> de Rosario
            compró MegaPack + Torso Definido 💪
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}